import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {labels} from '../../../../util/uiconstants';
import Loader from '../../../Common/Loaders/loadingindicator';
import env from '../../../../util/env';
import {deleteTemplate} from '../../../../actions/admin/templatemanagementaction';
import styled from 'styled-components';
import TicketField from '../../common/ticketfield';
import {getLocalizedAPIError, validateTicketNumber} from '../../common/util';
import Toast from '../../../Common/Toast/Toast';

const Deletetemplate = styled.section`
	.modal-footer {
		width: 100%;
		padding: var(--spacing-x-large);
		display: inline-flex;
		justify-content: end;
		button {
			margin-left: var(--px-12);
		}
	}

	.deletetemplate-loader {
		padding: var(--px-24) !important;
	}

	.deletetemplate {
		padding: var(--spacing-x-large);
		.confirmationmessage {
			padding-bottom: var(--spacing-x-large);
			border-bottom: var(--px-1) solid var(--neutrals-200);
		}
		.templateName {
			padding: var(--spacing-x-large) 0;
		}
		//ticketstart
		.ticketdetail {
			.description {
				padding-bottom: var(--spacing-small);
			}
			.motif-form-field {
				width: var(--px-400);
				.motif-input {
					height: var(--px-44);
				}
			}
		}
		//ticketend
	}
`;

function TemplateDelete(props) {
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);
	const dispatch = useDispatch();

	const onTicketChanged = (e) => {
		setTicketNumber(e.target.value);
	};

	const onDeleteClick = () => {
		setIsSubmitClicked(true);
		if (!validateTicketNumber(ticketNumber)) {
			return;
		}

		let uriTicketNumber = encodeURIComponent(ticketNumber.trim());

		setIsLoading(true);
		let deleteTemplateUrl =
			env.getURL('serviceUrlV2') +
			'admin/engagementtemplates/' +
			props.deleteTemplateData?.copyRequestId +
			'?ticketNumber=' +
			uriTicketNumber;
		dispatch(deleteTemplate(deleteTemplateUrl))
			.then(() => {
				props.setIsTemplateDeleted(true);
			})
			.catch((e) => {
				setErrorMessage(getLocalizedAPIError(e));
			})
			.finally(() => {
				setIsLoading(false);
				setIsSubmitClicked(false);
				props.closeEditTemplateModal();
			});
	};

	return (
		<Deletetemplate>
			<section
				className="toastMessage"
				style={{
					display: errorMessage && errorMessage.length > 0 ? 'block' : 'none'
				}}
			>
				<Toast variant="error" onClose={() => setErrorMessage(false)}>
					{errorMessage}
				</Toast>
			</section>
			{isLoading ? (
				<section className="deletetemplate-loader">
					<Loader show view="blockView" styleName="loadingstyle" />
				</section>
			) : (
				<section className="deletetemplate customScrollbar">
					<section
						className="confirmationmessage motif-body1-default-light"
						aria-label="message"
					>
						{labels.templateDeleteConfirmationMessage}
					</section>
					<section
						className="templateName motif-body1-default-regular"
						aria-label="templatename"
					>
						{props?.deleteTemplateData?.templateName}
					</section>
					<TicketField
						ticketNumber={ticketNumber}
						onTicketChanged={onTicketChanged}
						showValidation={isSubmitClicked}
					/>
				</section>
			)}
			<section className="modal-footer">
				<MotifButton
					variant="ghost"
					size="medium"
					onClick={() => props.closeEditTemplateModal()}
					disabled={isLoading}
				>
					{labels.templateEditCancel}
				</MotifButton>
				<MotifButton
					variant="primary"
					size="medium"
					disabled={ticketNumber.trim().length <= 0 || isLoading}
					onClick={() => onDeleteClick()}
				>
					{labels.templateEditDelete}
				</MotifButton>
			</section>
		</Deletetemplate>
	);
}

export default TemplateDelete;
